import { useMemo, useState } from 'react';

export const useHeaderPeepingDataInitialiser = () => {
  const [isHeaderPeeping, setIsHeaderPeeping] = useState(false);

  const data = useMemo(
    () => ({
      isHeaderPeeping,
      setIsHeaderPeeping,
    }),
    [isHeaderPeeping]
  );

  return data;
};
